import useDidMount from './useDidMount';
import { useLanguage } from './useLanguage';

import { PUSH_AXEPTIO_TIMEOUT } from '../utils/variables';

export const useAxeptio = () => {
  const { langKey } = useLanguage();
  const openAxeptioPopUp = () => {
    const isBrowser = typeof window !== 'undefined';
    if (!isBrowser) {
      return;
    }
    try {
      return window.openAxeptioCookies();
    } catch (error) {
      return;
    }
  };

  const pushAxeptioScript = (langKey = 'en') =>
    window?._axcb?.push((sdk) => {
      sdk.setCookiesVersion(`convelio-base_${langKey === 'fr' ? 'FR' : 'EN'}`);
    });

  useDidMount(() => {
    const timer = setTimeout(() => {
      pushAxeptioScript(langKey);
    }, PUSH_AXEPTIO_TIMEOUT);
    return () => clearTimeout(timer);
  }, [langKey]);

  return { openAxeptioPopUp };
};
